import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=6b476505&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=ts&"
export * from "./baseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=6b476505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b476505",
  null
  
)

export default component.exports